/* Native variants/cart own pricing, stock, requests and discounts. This module adds only explicit choice/focus and an in-flow app dock. */
(() => {
  if (window.jordanConceptA) return;
  window.jordanConceptA = true;
  const initialize = () => {
    document.querySelectorAll('[data-jordan-a-product]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      let chosen = Boolean(root.querySelector('variant-picker[data-selected-variant]')); 
      let focusId = null;
      // Preview-only alternate selection must survive the native variant URL rewrite.
      const previewView = new URLSearchParams(location.search).get('view');
      const bindPreviewPicker = () => {
        if (previewView !== 'jordan-concept-a') return;
        root.querySelectorAll('variant-picker').forEach(picker => {
          if (picker.jordanPreviewBound || typeof picker.getFetchUrl !== 'function') return;
          picker.jordanPreviewBound = true;
          const getFetchUrl = picker.getFetchUrl;
          const updateURL = picker.updateURL;
          picker.getFetchUrl = function (...args) {
            const url = new URL(getFetchUrl.apply(this, args), location.origin);
            url.searchParams.set('view', previewView);
            return url.pathname + url.search;
          };
          picker.updateURL = function (...args) {
            updateURL.apply(this, args);
            const url = new URL(location.href);
            url.searchParams.set('view', previewView);
            history.replaceState(history.state, '', url.pathname + url.search + url.hash);
          };
        });
      };
      customElements.whenDefined('variant-picker').then(bindPreviewPicker);
      const button = () => root.querySelector('button[name="add"]');
      const sync = () => {
        bindPreviewPicker();
        if (focusId && !root.contains(document.activeElement)) {
          const input = document.getElementById(focusId);
          if (input) { input.focus({ preventScroll: true }); focusId = null; }
        }
        // Variant stock is only meaningful once a size is chosen.
        if (chosen) delete root.dataset.jordanAAwaitingSize; else root.dataset.jordanAAwaitingSize = '';
        const btn = button();
        if (!btn) return;
        if (chosen) {
          if (btn.dataset.jordanAAria) { btn.setAttribute('aria-label', btn.dataset.jordanAAria); delete btn.dataset.jordanAAria; }
          return;
        }
        btn.disabled = true;
        const label = btn.querySelector('[data-button-text]') || btn.querySelector('.product-buy-btn__text-label');
        if (label && label.textContent !== 'בחרו מידה להוספה לסל') label.textContent = 'בחרו מידה להוספה לסל';
        // Keep the accessible name in step with the visible prompt while no size is chosen.
        if (btn.getAttribute('aria-label') !== 'בחרו מידה להוספה לסל') {
          btn.dataset.jordanAAria = btn.getAttribute('aria-label') || '';
          btn.setAttribute('aria-label', 'בחרו מידה להוספה לסל');
        }
      };
      root.addEventListener('change', event => {
        if (event.target.matches('.product-variant-picker__form input[type="radio"]')) {
          chosen = true;
          if (document.activeElement === event.target) focusId = event.target.id;
          sync();
        }
      }, true);
      root.addEventListener('submit', event => {
        if (event.target.matches('form[data-type="add-to-cart-form"]') && !chosen) {
          event.preventDefault(); event.stopImmediatePropagation();
          root.querySelector('.product-variant-picker__form input:not(:disabled)')?.focus();
        }
      }, true);
      root.addEventListener('focusin', event => {
        if (event.target.matches('.product-variant-picker__form input')) {
          root.querySelectorAll('.pill[data-jordan-a-focus]').forEach(label => label.removeAttribute('data-jordan-a-focus'));
          root.querySelectorAll('label').forEach(label => { if (label.htmlFor === event.target.id) label.setAttribute('data-jordan-a-focus', ''); });
        }
      });
      root.addEventListener('focusout', () => root.querySelectorAll('.pill[data-jordan-a-focus]').forEach(label => label.removeAttribute('data-jordan-a-focus')));
      root.addEventListener('keydown', event => {
        if (event.target.matches('product-modal-button') && ['Enter', ' '].includes(event.key)) { event.preventDefault(); event.target.click(); }
      });
      new MutationObserver(sync).observe(root, { childList:true, subtree:true });
      sync();
    });
    const dock = document.querySelector('[data-jordan-a-service]');
    if (!dock || dock.dataset.observing) return;
    dock.dataset.observing = 'true';
    const place = () => {
      const host = document.querySelector('whatsapp-chat-by-squadkin');
      if (!host?.shadowRoot) return false;
      if (host.parentElement !== dock) dock.append(host);
      if (!host.shadowRoot.querySelector('[data-jordan-a-dock]')) {
        const style = document.createElement('style');
        style.dataset.jordanADock = '';
        style.textContent = '.squadkin-wrapper-container{position:relative!important;inset:auto!important;--sk-bottom:0px!important;margin:0!important;transform:none!important}';
        host.shadowRoot.append(style);
      }
      return true;
    };
    place();
    const observer = new MutationObserver(place);
    observer.observe(document.documentElement, { childList:true,subtree:true });
    setTimeout(() => observer.disconnect(), 15000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
// Floating controls on these templates only shift vertically, never hide: the accessibility app's own launcher
// (least central corner: bottom-left on single-column mobile where RTL lines end, the app's bottom-right beside the
// gallery from 768px, via jordan-a.css) and the native sticky mobile filter button on the collection. Neither may
// cover size/CTA/WhatsApp controls, the Jordan details +/- toggles and row icons, or the other control, and each
// moves off price/offer/fit/stock/trust/description, details headings and open details text,
// card names/prices and 1+1 chips (preferring the lower half; higher only when the lower half has no free slot).
(() => {
  if (window.jordanConceptAAccess) return;
  window.jordanConceptAAccess = true;
  const HARD_GAP = 8, SOFT_GAP = 4, STEP = 4;
  const HARD = [
    '[data-jordan-a-product] .product-variant-picker',
    '[data-jordan-a-product] .product-form__buttons',
    '[data-jordan-a-product] button[name="add"]',
    '.jordan-a-service',
    // Details group on the Jordan PDP (a separate native section): its +/- toggles and row icons stay uncovered.
    '.shopify-section[id$="__product-details"] accordeon-button .accordeon-plus__icon',
    '.shopify-section[id$="__product-details"] accordeon-button .accordeon-plus__btn-icon'
  ].join(',');
  const SOFT = [
    '.jordan-a-product .product__info > *:not(.product-related-products-block)',
    '.jordan-a-model-note',
    '.jordan-a-collection-header',
    '.jordan-a-collection .product-card__info',
    '.jordan-a-collection .product-card__on-image-badges',
    '.shopify-section[id$="__product-details"] accordeon-button',
    '.shopify-section[id$="__product-details"] accordeon-component[data-aria-expanded="true"] [data-accordeon-content]'
  ].join(',');
  const launcher = () => document.getElementById('mic-access-tool-general-button');
  const filterButton = () => document.querySelector('.jordan-a-collection sidebar-filters-sticky-mobile-button');
  const visibleRect = el => { const r = el?.getBoundingClientRect(); return r && r.width && r.height && r.bottom > 0 && r.top < innerHeight && getComputedStyle(el).opacity !== '0' ? r : null; };
  const overlaps = (r, box, offset, gap) => r.left < box.right + gap && r.right > box.left - gap && r.top < box.bottom - offset + gap && r.bottom > box.top - offset - gap;
  const hardRects = other => {
    const list = [...document.querySelectorAll(HARD)];
    const whatsapp = document.querySelector('whatsapp-chat-by-squadkin');
    if (whatsapp) list.push(whatsapp.shadowRoot?.querySelector('.squadkin-wrapper-container') || whatsapp);
    const rects = list.map(visibleRect).filter(Boolean);
    const o = visibleRect(other());
    if (o) rects.push(o);
    return rects;
  };
  // Text line boxes (not whole blocks) so empty RTL line ends stay usable.
  const softRects = box => {
    const out = [];
    for (const block of document.querySelectorAll(SOFT)) {
      const b = block.getBoundingClientRect();
      if (!b.width || b.bottom < 0 || b.top > innerHeight || b.right < box.left - SOFT_GAP || b.left > box.right + SOFT_GAP) continue;
      const walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT);
      for (let node; (node = walker.nextNode());) {
        if (!node.textContent.trim()) continue;
        const range = document.createRange();
        range.selectNodeContents(node);
        for (const r of range.getClientRects()) if (r.width && r.bottom > 0 && r.top < innerHeight) out.push(r);
      }
      for (const media of block.querySelectorAll('img,svg')) { const r = media.getBoundingClientRect(); if (r.width && r.bottom > 0 && r.top < innerHeight) out.push(r); }
    }
    return out;
  };
  const avoider = (element, other) => {
    let shift = 0;
    return () => {
      const el = element();
      if (!el || !document.querySelector('.jordan-a-product,.jordan-a-collection')) return;
      const current = el.getBoundingClientRect();
      if (!current.width) return;
      const box = { top: current.top + shift, bottom: current.bottom + shift, left: current.left, right: current.right };
      const header = document.querySelector('header-component, .header');
      const minTop = Math.max(HARD_GAP, header ? header.getBoundingClientRect().bottom + HARD_GAP : HARD_GAP);
      const maxAll = Math.max(0, box.top - minTop);
      const maxLower = Math.min(maxAll, Math.max(0, box.top - innerHeight / 2));
      const hard = hardRects(other);
      const soft = softRects(box);
      const clear = (offset, withSoft) => !hard.some(r => overlaps(r, box, offset, HARD_GAP)) && (!withSoft || !soft.some(r => overlaps(r, box, offset, SOFT_GAP)));
      const find = (from, to, withSoft) => { for (let o = from; o <= to; o += STEP) if (clear(o, withSoft)) return o; return null; };
      // Prefer a text-free slot in the lower half, then any text-free slot below the header (purchase copy outranks
      // staying low), and only then the nearest slot that merely avoids the controls.
      const next = find(0, maxLower, true) ?? find(maxLower + STEP, maxAll, true) ?? find(0, maxLower, false) ?? find(maxLower + STEP, maxAll, false) ?? 0;
      if (next !== shift) {
        shift = next;
        el.style.transform = shift ? `translateY(${-shift}px)` : '';
      }
    };
  };
  const updates = [avoider(launcher, filterButton), avoider(filterButton, launcher)];
  let frame = 0;
  const schedule = () => { if (!frame) frame = requestAnimationFrame(() => { frame = 0; updates.forEach(update => update()); }); };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  addEventListener('transitionend', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['is-visible', 'data-aria-expanded'] });
  schedule();
})();

// Details group (native product-details accordions on the Jordan PDP): the native <accordeon-button> toggles on Enter
// only and exposes no role/state, collapsed panels keep their links in the tab order, and while the keyboard is in use
// the native focusout handler re-opens every collapsed row the focus passes (tabbing the six headings rebuilt the wall).
// Here only: button semantics + mirrored state, Space support, collapsed panels inert, and no focusout re-opening.
(() => {
  if (window.jordanConceptADetails || !document.querySelector('.jordan-a-product')) return;
  window.jordanConceptADetails = true;
  const rows = () => document.querySelectorAll('.shopify-section[id$="__product-details"] accordeon-component');
  const sync = row => {
    const button = row.querySelector('accordeon-button');
    const content = row.querySelector('[data-accordeon-content-wrap]');
    if (!button) return;
    if (content && !content.id) content.id = `JordanADetails-${row.dataset.blockId || Math.random().toString(36).slice(2)}`;
    button.setAttribute('role', 'button');
    if (content) button.setAttribute('aria-controls', content.id);
    const expanded = row.getAttribute('data-aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (content) content.inert = !expanded;
  };
  document.addEventListener('focusout', event => {
    if (event.target.closest?.('.shopify-section[id$="__product-details"] accordeon-component')) event.stopPropagation();
  }, true);
  const init = () => rows().forEach(sync);
  document.addEventListener('keydown', event => {
    const button = event.target.closest?.('.shopify-section[id$="__product-details"] accordeon-button');
    if (!button || (event.key !== ' ' && event.key !== 'Spacebar')) return;
    event.preventDefault();
    button.click();
  });
  new MutationObserver(records => records.forEach(r => { if (r.target.matches?.('accordeon-component')) sync(r.target); })).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['data-aria-expanded'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

// Native drawers/modals and the accessibility panel close to <body>; return focus to the control that opened them.
(() => {
  if (window.jordanConceptAFocusReturn) return;
  window.jordanConceptAFocusReturn = true;
  const TRIGGERS = '.jordan-a-product product-modal-button, .jordan-a-product .product-variant-picker button, #mic-access-tool-general-button';
  const CLOSERS = '#mic-access-tool-box-close-button, .product-modal__close-button-with-scale-hover, .product-information-drawer__header-close-button-wrapper, [data-sidebar-close], modal-button.close, .close-button';
  let trigger = null;
  const remember = event => { const t = event.target.closest?.(TRIGGERS); if (t) trigger = t; };
  const stranded = el => !el || el === document.body || el === document.documentElement || !el.getClientRects().length ||
    getComputedStyle(el).visibility === 'hidden' || !!el.closest('product-modal:not(.is-opened), #mic-access-tool-box:not(.opened-mic-access-tool)');
  const restore = () => setTimeout(() => {
    if (!trigger?.isConnected || !stranded(document.activeElement)) return;
    trigger.focus({ preventScroll: true });
    trigger = null;
  }, 450);
  document.addEventListener('click', event => { remember(event); if (event.target.closest?.(CLOSERS)) restore(); }, true);
  document.addEventListener('keyup', event => { if (event.key === 'Escape') restore(); });
  // Custom close controls (e.g. <modal-button>) close on Enter/Space keydown without a click event.
  document.addEventListener('keydown', event => { if ((event.key === 'Enter' || event.key === ' ') && event.target.closest?.(CLOSERS)) restore(); }, true);
})();

// Jordan collection: a deliberate page change (click/Enter on a native pagination link) lands on the new page's
// results toolbar below the sticky header. Native PaginationLink replaces #ShopProductsGrid, smooth-scrolls only the
// grid edge (ignoring the sticky header; layout shifts can strand it low) and leaves focus on <body>. URLs, query
// parameters and pushState stay native. Landing only happens for the page the activated link targeted; any other
// navigation intent (popstate, filter/sort change, other clicks) disarms it.
(() => {
  if (window.jordanConceptAPagination || !document.querySelector('.jordan-a-collection')) return;
  window.jordanConceptAPagination = true;
  const WINDOW_MS = 15000;
  const root = () => document.querySelector('.jordan-a-collection');
  const query = () => location.search.slice(1);
  const pageOf = search => new URLSearchParams(search).get('page') || '1';
  let armed = null; // { at, grid, page }
  // Each landing gets a generation; any later user intent (Back/Forward, filter/sort, other click, keys, wheel/touch)
  // bumps it, so pending re-checks never pull the page back after the user has moved on.
  let generation = 0;
  const disarm = () => { armed = null; generation++; };
  // Native ShopComponent's popstate handler reads state.searchParams as a bare query string, but PaginationLink stores
  // the full path ("?/collections/…?page=2" on Back). Entries created by a deliberate page change are re-written in
  // that format and marked as Jordan-owned; nothing else in history is touched.
  const own = () => history.replaceState({ ...(history.state || {}), searchParams: query(), jordanAPage: true }, '', location.href);
  const arm = event => {
    const link = event.target.closest?.('pagination-link');
    if (!link || !link.closest('.jordan-a-collection pagination-component') || !link.dataset.url) { disarm(); return; }
    own(); // the entry being left, so Back returns to it in the native format
    armed = { at: Date.now(), grid: document.getElementById('ShopProductsGrid'), page: pageOf(new URL(link.dataset.url, location.origin).search) };
  };
  document.addEventListener('click', arm, true);
  document.addEventListener('keydown', event => { if (event.key === 'Enter') arm(event); else disarm(); }, true);
  ['change', 'submit'].forEach(type => document.addEventListener(type, disarm, true));
  ['wheel', 'touchmove'].forEach(type => addEventListener(type, () => { generation++; }, { passive: true }));
  // While Back/Forward lands on a Jordan-owned entry, the native handler re-pushes that same URL, which drops the
  // forward entries and traps the user. Only an exact duplicate of the current Jordan-owned entry (same URL and
  // searchParams) is turned into replaceState; every other pushState, including real filter/sort changes, is native.
  addEventListener('popstate', () => { disarm(); const el = document.getElementById('JordanAPageStatus'); if (el) el.textContent = ''; }, true);
  // The collection's landing entry has null state, which the native handler cannot read on Back (it throws and keeps
  // the old grid); give this Jordan page's own entry the native format once.
  if (history.state == null) history.replaceState({ searchParams: query(), jordanAPage: true }, '', location.href);
  const nativePush = history.pushState;
  history.pushState = function (state, title, url) {
    const current = history.state;
    const target = new URL(url == null ? location.href : url, location.href);
    const same = target.pathname + target.search === location.pathname + location.search;
    if (current?.jordanAPage && state && typeof state.searchParams === 'string' && state.searchParams === current.searchParams && same) {
      return history.replaceState({ ...state, jordanAPage: true }, title, url);
    }
    return nativePush.apply(this, arguments);
  };
  const status = container => {
    let el = document.getElementById('JordanAPageStatus');
    if (!el) {
      el = document.createElement('p');
      el.id = 'JordanAPageStatus';
      el.className = 'jordan-a-sr-status';
      el.setAttribute('role', 'status');
      container.prepend(el);
    }
    return el;
  };
  // Land the results toolbar just below whatever header is actually visible. The desktop header is a hide-on-scroll
  // sticky section whose card sits ~19px down and slides in on upward scroll, so it is re-measured after landing and
  // only relative corrections follow (no re-jump that would toggle the header again).
  const anchorOf = container => container.querySelector('.shop__container') || document.getElementById('ShopProductsGrid');
  const visibleHeaderBottom = () => {
    const header = document.querySelector('header-component, .header');
    if (!header) return 0;
    const r = header.getBoundingClientRect();
    const stuck = [header, header.closest('.shopify-section, header')].some(el => el && /sticky|fixed/.test(getComputedStyle(el).position));
    return stuck && r.bottom > 0 && r.top < innerHeight / 2 ? r.bottom : 0;
  };
  // When the results start within the first half-screen of the document (desktop: header + intro are short), the
  // page top already shows header, intro, toolbar and first row; landing there avoids the header's reveal zone.
  let landedAtTop = false;
  const align = (container, first, gen) => {
    if (gen !== generation) return;
    const anchor = anchorOf(container);
    if (!anchor) return;
    if (first) landedAtTop = anchor.getBoundingClientRect().top + scrollY <= innerHeight / 2;
    if (landedAtTop) { if (first || scrollY !== 0) scrollTo({ top: 0, behavior: 'instant' }); return; }
    if (first) scrollTo({ top: Math.max(0, Math.round(anchor.getBoundingClientRect().top + scrollY - 8 - visibleHeaderBottom())), behavior: 'instant' });
    const delta = Math.round(anchor.getBoundingClientRect().top - (visibleHeaderBottom() + 8));
    if (Math.abs(delta) > 2) scrollBy({ top: delta, behavior: 'instant' });
  };
  const land = results => {
    const container = root();
    if (!container) return;
    own();
    const shop = container.querySelector('shop-component');
    if (shop && 'searchParamsPrev' in shop) shop.searchParamsPrev = query();
    const gen = ++generation;
    align(container, true, gen);
    requestAnimationFrame(() => align(container, false, gen));
    setTimeout(() => align(container, false, gen), 450);
    setTimeout(() => align(container, false, gen), 900);
    results.setAttribute('tabindex', '-1');
    results.focus({ preventScroll: true });
    status(container).textContent = `עמוד ${pageOf(location.search)} · ${results.querySelectorAll('.shop__grid-item').length} מוצרים`;
  };
  new MutationObserver(() => {
    if (!armed) return;
    if (Date.now() - armed.at > WINDOW_MS) { disarm(); return; }
    const current = document.getElementById('ShopProductsGrid');
    if (!current || current === armed.grid) return;
    // Native pushState has run by now (observer callbacks follow the replacing task); only land on the targeted page.
    const target = armed.page;
    disarm();
    if (pageOf(location.search) === target) land(current);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
